import { createTheme } from 'visitor-ui-component-library/theme/createTheme';
import { setPrimaryColor, setTextColor } from 'visitor-ui-component-library/theme/defaultThemeOperators';
export default createTheme(setPrimaryColor('#00a4bd'), setTextColor('white'));